// features/bookmarks/panels/FoldersPanel.tsx — My Folders rail (filter + Manage).
import styled from 'styled-components';
import { Panel, SectionLabel, Button } from '@/ui';
import type { Bookmark, BookmarkFolder } from '@/core/models/bookmark';

export interface FoldersPanelProps {
  bookmarks: Bookmark[];
  folders: BookmarkFolder[];
  activeFolder: string;
  onFolderChange: (folderId: string) => void;
  onManage: () => void;
}

const Row = styled.button<{ $active: boolean }>`
  display: flex; align-items: center; justify-content: space-between; width: 100%;
  padding: 8px 10px; border: none; cursor: pointer; border-radius: ${({ theme }) => theme.radius.sm};
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  background: ${({ theme, $active }) => ($active ? theme.color.glassBorder : 'transparent')};
  color: ${({ theme }) => theme.color.textPrimary};
  &:hover { background: ${({ theme }) => theme.color.glassBorder}; }
`;
const Count = styled.span`color: ${({ theme }) => theme.color.textMuted};`;
const ManageWrap = styled.div`margin-top: 10px;`;

export function FoldersPanel({ bookmarks, folders, activeFolder, onFolderChange, onManage }: FoldersPanelProps) {
  const countFor = (id: string) => bookmarks.filter((b) => b.folderId === id).length;
  return (
    <Panel>
      <SectionLabel as="h2">My Folders</SectionLabel>
      <Row type="button" $active={activeFolder === 'all'} aria-pressed={activeFolder === 'all'} onClick={() => onFolderChange('all')}>
        <span>All Bookmarks</span><Count>{bookmarks.length}</Count>
      </Row>
      {folders.map((f) => (
        <Row key={f.id} type="button" $active={activeFolder === f.id} aria-pressed={activeFolder === f.id} onClick={() => onFolderChange(f.id)}>
          <span>{f.name}</span><Count>{countFor(f.id)}</Count>
        </Row>
      ))}
      <ManageWrap>
        <Button variant="secondary" onClick={onManage}>Manage Folders</Button>
      </ManageWrap>
    </Panel>
  );
}
